import React, {PureComponent} from 'react';
import {IconX, Type} from '@spotify-internal/encore-web';
import classnames from 'classnames';

import {notificationPropType} from 'utils/custom-proptypes';

import styles from './NotificationBanner.module.scss';

class NotificationBanner extends PureComponent {
  static propTypes = {
    notification: notificationPropType,
  };

  constructor(props) {
    super(props);

    this.state = {
      hidden: false,
    };
  }

  hideBanner = () => {
    this.setState({hidden: true});
  };

  render() {
    const {notification} = this.props;
    const {hidden} = this.state;

    if (hidden) {
      return null;
    }

    return (
      <div className={classnames(styles.banner, styles[notification.type])}>
        <div className={styles.content}>
          <button className={styles.close} onClick={this.hideBanner}>
            <IconX aria-label="IconClose" iconSize={16} />
          </button>
          <Type.p variant={Type.body1} dangerouslySetInnerHTML={{__html: notification.body}} />
          <p>{notification.lastUpdated}</p>
        </div>
      </div>
    );
  }
}

export default NotificationBanner;
